import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDelayReasonAvailableColumns,  } from './api';

export const path = '/delay-reason/list';

const PageDelayReasons: React.FC = (props) => {
  const DelayReasons = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getDelayReasonAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <DelayReasons {...props} />;
};

export default PageDelayReasons;
